var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.wrapper},[_vm._t("header"),_c('div',{class:[_vm.$style.content, _vm.isDark && _vm.$style.isDark]},[_c('div',{class:_vm.$style.contentWrapper,attrs:{"id":"content"}},[_vm._t("default")],2),_vm._t("footer")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }